import { render, staticRenderFns } from "./OnboardingErrorCameraIos.vue?vue&type=template&id=2d5ffe4e&scoped=true"
import script from "./OnboardingErrorCameraIos.vue?vue&type=script&lang=js"
export * from "./OnboardingErrorCameraIos.vue?vue&type=script&lang=js"
import style0 from "./OnboardingErrorCameraIos.vue?vue&type=style&index=0&id=2d5ffe4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5ffe4e",
  null
  
)

export default component.exports